
export const BASE_URL = 'https://landnest.net:81';


// export const BASE_URL = 'http://46.37.122.105:89';
// export const Notification_Url = 'http://localhost:5000';
//export const Notification_Url = 'https://landnest-pushnotification.vercel.app';
export const Notification_Url = 'https://landnest.net:5000';

export const GOOGLEMAPS_API_KEY = 'AIzaSyAZAU88Lr8CEkiFP_vXpkbnu1-g-PRigXU';

export const VENDORS_URL = `${BASE_URL}/vendors`;
export const CATEGORIES_URL = `${BASE_URL}/categories`; // For vendor categories
